import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import {useTranslation} from "../../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import React, {useCallback, useEffect, useRef} from "react";
import {cmpClassName, execFn} from "../../../../common/generic-react.functions.js";
import {DEFAULT_SKINNING, FormRowContainer, FormTitleRowContainer} from "../../../../common/generic-react.styles.js";
import Form from "../../../../components/atoms/form/form.component.js";
import Input from "../../../../components/atoms/input/input.component.js";
import SectionTitle from "../../../../components/atoms/section-title/section-title.component.js";
import Title from "../../../../components/atoms/title/title.component.js";
import ColorPicker from "../../../../components/molecules/color-picker/color-picker.component.js";
import HelpIcon from "../../../../components/molecules/help-icon/help-icon.component.js";
import ImageUploader from "../../../../components/molecules/image-uploader/image-uploader.component.js";
import {withReduxAndStyle} from "../../../../hoc/bridge.hoc.js";
import {useWhiteLabelItemGenerator} from "./white-label-detail.hooks.js";
import {WhiteLabelDetailFormContainer, WhiteLabelMainContainer} from "./white-label-detail.styles.js";
function WhiteLabelSkiningDetailPage({
  jwt,
  id,
  whitelabelItem,
  onSubmitSkining,
  onCancel,
  onChange,
  isDisabled
}) {
  const {
    t,
    tHtml
  } = useTranslation();
  const {
    wltitle,
    customConfig: [, setCustomConfig, resetCustomConfig]
  } = useWhiteLabelItemGenerator({
    id,
    jwt,
    onChange
  });
  const skiningformRef = useRef(null);
  const _onCancel = useCallback(() => {
    execFn(onCancel, id);
  }, [id, onCancel]);
  const filterLogos = useCallback((params) => {
    return {
      ...params,
      white_label: {
        ...params.white_label,
        principal_logo: params?.white_label?.principal_logo?.startsWith("filename:") ? "data:" + params?.white_label?.principal_logo?.split(":data:")[1] : params?.white_label?.principal_logo,
        public_logo: params?.white_label?.public_logo?.startsWith("filename:") ? "data:" + params?.white_label?.public_logo?.split(":data:")[1] : params?.white_label?.public_logo,
        favicon_logo: params?.white_label?.favicon_logo?.startsWith("filename:") ? "data:" + params?.white_label?.favicon_logo?.split(":data:")[1] : params?.white_label?.favicon_logo,
        mobile_in_app_logo: params?.white_label?.mobile_in_app_logo?.startsWith("filename:") ? "data:" + params?.white_label?.mobile_in_app_logo?.split(":data:")[1] : params?.white_label?.mobile_in_app_logo,
        mobile_app_skin_logo: params?.white_label?.mobile_app_skin_logo?.startsWith("filename:") ? "data:" + params?.white_label?.mobile_app_skin_logo?.split(":data:")[1] : params?.white_label?.mobile_app_skin_logo
      }
    };
  }, []);
  const getAllValues = useCallback(() => {
    return {
      ...skiningformRef.current?.getAllValues()
    };
  }, []);
  const _onSkinningSubmit = useCallback(() => {
    const contents = getAllValues();
    if (contents) {
      execFn(onSubmitSkining, contents, true, whitelabelItem);
    }
  }, [getAllValues, onSubmitSkining]);
  const setConfig = useCallback((values) => {
    setCustomConfig(values || filterLogos(getAllValues()));
  }, [filterLogos, getAllValues, setCustomConfig]);
  useEffect(() => {
    return () => {
      resetCustomConfig();
    };
  }, [resetCustomConfig]);
  const changeEdit = useCallback(() => {
    const values = filterLogos(getAllValues());
    setConfig(values);
    execFn(onChange, values);
  }, [setConfig, onChange, filterLogos, getAllValues]);
  return /* @__PURE__ */ React.createElement(WhiteLabelMainContainer, {
    className: cmpClassName("white-label-detail")
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(_StyledTitle, null, wltitle.toUpperCase())), /* @__PURE__ */ React.createElement(WhiteLabelDetailFormContainer, null, /* @__PURE__ */ React.createElement(Form, {
    ref: skiningformRef,
    onCancel: _onCancel,
    onSubmit: _onSkinningSubmit,
    validation: "onsubmit",
    isDisabled
  }, /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(Input, {
    name: "name",
    size: "sm",
    label: t("whiteLabel.content.mainForm.name"),
    value: whitelabelItem?.name,
    onChange: changeEdit,
    required: true
  })), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(_StyledHelpIcon, {
    text: tHtml("whiteLabel.content.themeSection.help")
  }, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h3",
    bold: false
  }, t("whiteLabel.content.themeSection.title")))), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.primary_color",
    size: "sm",
    value: whitelabelItem?.primary_color || DEFAULT_SKINNING.primary_color,
    label: t("whiteLabel.content.themeSection.primary"),
    onChangeComplete: changeEdit,
    required: true
  }), /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.secondary_color",
    size: "sm",
    value: whitelabelItem?.secondary_color || DEFAULT_SKINNING.secondary_color,
    label: t("whiteLabel.content.themeSection.secondary"),
    onChangeComplete: changeEdit,
    required: true
  }), /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.tertiary_color",
    size: "sm",
    value: whitelabelItem?.tertiary_color || DEFAULT_SKINNING.tertiary_color,
    label: t("whiteLabel.content.themeSection.tertiary"),
    onChangeComplete: changeEdit,
    required: true
  })), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.success_color",
    size: "xs",
    value: whitelabelItem?.success_color || DEFAULT_SKINNING.success_color,
    label: t("whiteLabel.content.themeSection.success"),
    onChangeComplete: changeEdit,
    required: true
  }), /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.warning_color",
    size: "xs",
    value: whitelabelItem?.warning_color || DEFAULT_SKINNING.warning_color,
    label: t("whiteLabel.content.themeSection.warning"),
    onChangeComplete: changeEdit,
    required: true
  }), /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.error_color",
    size: "xs",
    value: whitelabelItem?.error_color || DEFAULT_SKINNING.error_color,
    label: t("whiteLabel.content.themeSection.error"),
    onChangeComplete: changeEdit,
    required: true
  }), /* @__PURE__ */ React.createElement(ColorPicker, {
    name: "white_label.aux_color",
    size: "xs",
    value: whitelabelItem?.aux_color || DEFAULT_SKINNING.aux_color,
    label: t("whiteLabel.content.themeSection.aux"),
    onChangeComplete: changeEdit,
    required: true
  })), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(_StyledHelpIcon2, {
    text: tHtml("whiteLabel.content.logoSection.help")
  }, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h3",
    bold: false
  }, t("whiteLabel.content.logoSection.title"))), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(ImageUploader, {
    name: "white_label.principal_logo",
    width: "220px",
    height: "150px",
    value: whitelabelItem?.principal_logo,
    label: t("whiteLabel.content.logoSection.principal"),
    onComplete: changeEdit,
    onDelete: changeEdit
  }), /* @__PURE__ */ React.createElement(ImageUploader, {
    name: "white_label.mobile_in_app_logo",
    width: "220px",
    height: "150px",
    value: whitelabelItem?.mobile_in_app_logo,
    label: t("whiteLabel.content.logoSection.mobileInApp"),
    onComplete: changeEdit,
    onDelete: changeEdit
  }))), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(_StyledHelpIcon3, {
    text: tHtml("whiteLabel.content.urlSection.help")
  }, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h2",
    bold: true
  }, t("whiteLabel.content.urlSection.titleadvance")))), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h3",
    bold: false
  }, t("whiteLabel.content.urlSection.title")), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(Input, {
    name: "white_label.web_url",
    size: "sm",
    disabled: true,
    label: t("whiteLabel.content.urlSection.form.web"),
    value: whitelabelItem?.web_url || DEFAULT_SKINNING.web_url
  }), /* @__PURE__ */ React.createElement(Input, {
    name: "white_label.api_url",
    size: "sm",
    disabled: true,
    label: t("whiteLabel.content.urlSection.form.api"),
    value: whitelabelItem?.api_url || DEFAULT_SKINNING.api_url
  }), /* @__PURE__ */ React.createElement(Input, {
    name: "white_label.media_url",
    size: "sm",
    disabled: true,
    label: t("whiteLabel.content.urlSection.form.media"),
    value: whitelabelItem?.media_url || DEFAULT_SKINNING.media_url
  }), /* @__PURE__ */ React.createElement(Input, {
    name: "white_label.default_email",
    size: "sm",
    type: "email",
    disabled: true,
    label: t("whiteLabel.content.mainForm.fromEmail"),
    value: whitelabelItem?.default_email
  }), /* @__PURE__ */ React.createElement(Input, {
    name: "white_label.company_help_email",
    size: "sm",
    type: "email",
    disabled: true,
    label: t("whiteLabel.content.mainForm.helpEmail"),
    value: whitelabelItem?.company_help_email
  }))), /* @__PURE__ */ React.createElement(FormTitleRowContainer, null, /* @__PURE__ */ React.createElement(_StyledHelpIcon4, {
    text: tHtml("whiteLabel.content.logoSection.help")
  }, /* @__PURE__ */ React.createElement(SectionTitle, {
    tag: "h3",
    bold: false
  }, t("whiteLabel.content.logoSection.title"))), /* @__PURE__ */ React.createElement(FormRowContainer, null, /* @__PURE__ */ React.createElement(ImageUploader, {
    name: "white_label.public_logo",
    width: "220px",
    height: "150px",
    value: whitelabelItem?.public_logo,
    disabled: true,
    label: t("whiteLabel.content.logoSection.public"),
    onComplete: changeEdit,
    onDelete: changeEdit
  }), /* @__PURE__ */ React.createElement(ImageUploader, {
    name: "white_label.mobile_app_skin_logo",
    width: "220px",
    height: "150px",
    value: whitelabelItem?.mobile_app_skin_logo,
    disabled: true,
    label: t("whiteLabel.content.logoSection.mobileSkin"),
    onComplete: changeEdit,
    onDelete: changeEdit
  }), /* @__PURE__ */ React.createElement(ImageUploader, {
    name: "white_label.favicon_logo",
    width: "220px",
    height: "150px",
    value: whitelabelItem?.favicon_logo,
    disabled: true,
    label: t("whiteLabel.content.logoSection.favicon"),
    onComplete: changeEdit,
    onDelete: changeEdit
  }))))));
}
export default /* @__PURE__ */ React.memo(withReduxAndStyle(WhiteLabelSkiningDetailPage));
var _StyledTitle = _styled(Title).withConfig({
  displayName: "white-label-skining-detailpage___StyledTitle",
  componentId: "sc-9lxp6b-0"
})({
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  width: "100%"
});
var _StyledHelpIcon = _styled(HelpIcon).withConfig({
  displayName: "white-label-skining-detailpage___StyledHelpIcon",
  componentId: "sc-9lxp6b-1"
})({
  display: "flex",
  alignItems: "baseline"
});
var _StyledHelpIcon2 = _styled(HelpIcon).withConfig({
  displayName: "white-label-skining-detailpage___StyledHelpIcon2",
  componentId: "sc-9lxp6b-2"
})({
  display: "flex",
  alignItems: "baseline"
});
var _StyledHelpIcon3 = _styled(HelpIcon).withConfig({
  displayName: "white-label-skining-detailpage___StyledHelpIcon3",
  componentId: "sc-9lxp6b-3"
})({
  display: "flex",
  alignItems: "baseline"
});
var _StyledHelpIcon4 = _styled(HelpIcon).withConfig({
  displayName: "white-label-skining-detailpage___StyledHelpIcon4",
  componentId: "sc-9lxp6b-4"
})({
  display: "flex",
  alignItems: "baseline"
});
